import * as amplitude from "@amplitude/analytics-browser";
import axios from "axios";
import qs from "query-string";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { getBackendUrl } from "../../utils";
import SageBankFeedsConsent from "./SageBankFeedsConsent";

type SearchParams = {
  challenge: string;
  otp: string;
};

const SageBankFeedsRedirect: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const history = useHistory();
  const parsedSearch = qs.parse(history.location.search) as SearchParams;
  const { challenge, otp } = parsedSearch;

  const confirmConsent = () => {
    amplitude.track("Sage Bank Feeds: Oauth Redirect");
    setIsLoading(true);
    const params = qs.stringify({
      state: challenge,
      password: otp,
    });

    axios
      .get(`${getBackendUrl()}/sageBankFeedsConnector/auth-otp?${params}`)
      .then((response) => {
        amplitude.track("Sage Bank Feeds: Oauth OTP Success, redirecting...");
        setIsSuccess(true);
        setIsLoading(true);
        setTimeout(() => {
          window.location.replace(response.data.redirectUrl);
        }, 2500);
      })
      .catch((err) => {
        amplitude.track("Sage Bank Feeds: Oauth OTP Error");
        if (err.response?.data?.redirectUrl) {
          window.location.href = err.response.data.redirectUrl;
          return;
        }

        setErrorMessage(
          err.response?.data?.error_message ?? "Something went wrong.",
        );
        setIsLoading(false);
        setIsSuccess(false);
      });
  };

  return (
    <SageBankFeedsConsent
      confirmConsent={confirmConsent}
      isSuccess={isSuccess}
      isLoading={isLoading}
      errorMessage={errorMessage}
    />
  );
};

export default SageBankFeedsRedirect;
